import { Component, OnInit, OnDestroy, Input, Output, EventEmitter } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-confirmation',
  templateUrl: './confirmation.component.html',
  styleUrls: ['./confirmation.component.scss']
})
export class ConfirmationComponent implements OnInit, OnDestroy {

  @Input() access;
  @Input() title: string = "";
  @Input() bodyTxtAlert: string = "";
  @Input() buttonClass: string = "";
  @Input() deleteEntityName: string = "";
  @Input() type: any;
  @Input() bodyText: any;
  @Output() confirmAction: EventEmitter<any> = new EventEmitter();
  public bodyElem;

  public bodyTxt: string = "";
  public bodyTxt2: string = "";
  public notifyFlag: boolean = true;

  constructor(
    public activeModal: NgbActiveModal
  ) {}

  ngOnInit() {
    this.bodyElem = document.getElementsByTagName('body')[0];
    switch(this.access) {
      case 'sendnotification-users':
        this.bodyTxt = "Would you like to notify the users?";
        break;
      case 'Remove Vehicles':
        this.bodyTxt = "If you select <span>All Product Types</span>, all selected vehicle details will be removed";
        break;
      case 'Remove Probing Question':
        this.bodyTxt = "Would you like to delete the delete the probing question?";
        break;
      case 'Remove Voice':
        this.bodyTxt = "Would you like to delete the voice of customer?";
        break;
      case 'Publish':
        this.bodyTxt = "Would you like to publish?";
        break;
      case 'Save':
        this.bodyTxt = "Would you like to save?";
        break;
      case 'Cancel':
        this.bodyTxt = "Would you like to Discard changes?";
        break;
      case 'Parts Cancel':
        this.bodyTxt = "Discard Part changes?";
        break;
      case 'Cancel Upload':
        this.bodyTxt = "Would you like to cancel upload?";
        break;
      case 'Remove SIB Action':
        this.bodyTxt = "Would you like to remove SIB action?";
        break;
      case 'Remove Frame':
        this.bodyTxt = "Would you like to remove frame number?";
        break;
      case 'Remove User':
        this.bodyTxt = "Would you like to remove user?";
        break;
      case 'Delete':
        this.bodyTxt = "Would you like to delete?";
        break;
      case 'NDelete':
        this.bodyTxt = "Would you like to delete?";
        break;
      case 'DeleteRO':
        this.bodyTxt = "Would you like to cancel?";
        break;
      case 'Restore':
        this.bodyTxt = "Would you like to restore?";
        break;
        case 'DeleteWs':
        this.bodyTxt = "Are you sure you’d like to delete this worksteam?";
        break;
      case 'DeleteEntity':
        this.bodyTxt = "Would you like to delete "+this.deleteEntityName+"?";
        break;
      case 'Workstream Save':
        this.bodyTxt = "Notify users of workstream name change?";
        break;
      case 'document-metrics-discard':
         this.bodyTxt = "Would you like to hide this tech info in metrics?";
         break;
      case 'userdashboard discard':
        this.bodyTxt = "Discard Changes?";
        break;
      case 'userDelete':
        this.bodyTxt = "Are you sure you’d like to delete this user?";
        break;
      case 'multipleUserDelete':
        this.bodyTxt = `Are you sure you’d like to delete the users?`;
        break;
      case 'techDelete':
        this.bodyTxt = "Are you sure you’d like to delete this Technician?";
        break;
      case 'userRestore':
        this.bodyTxt = "Are you sure you’d like to restore this user?";
        break;
      case 'ThreadClose':
        this.bodyTxt = `Close this ${this.title}?`;
        break;
      case 'escalationAction':
        let titleCaps = this.title.toUpperCase();
        let titleLow = this.title.toLowerCase();
        this.bodyTxt = `CLOSE ${titleCaps} button is disabled because ${titleLow} <br/> escalation is not complete.`;
        break;
      case 'ThreadDelete':
        this.bodyTxt = `Delete  ${this.title}?`;
        break;
      case 'PostDelete':
        this.bodyTxt = `${this.title}?`;
        break;
      case 'Reset Vin':
        this.bodyTxt = "Invalid VIN";
        break;
      case 'Error Code Remove Warning':
        this.bodyTxt = "Remove Emission? <br/> The selected error codes will be removed.";
        break;
      case 'Vehicle Remove Warning':
        this.bodyTxt = "Remove Vehicle Details? <br/> The selected error codes will be removed.";
        break;
      case 'ppfrconfirmation':
        this.bodyTxt = "Are you sure you want to remove?";
        break;
      case 'nestedReplyAction':
        this.bodyTxt = `<span class="nested-text">Discard <span class="red-text">${this.title}</span> reply?</span>`;
        break;
      case 'nestedEditReplyAction':
        this.bodyTxt = `<span class="nested-text">Discard Edit <span class="red-text">${this.title}</span> reply?</span>`;
        break;
      case 'commentAction':
        this.bodyTxt = `<span class="nested-text">Discard comment?</span>`;
        break;
      case 'draftCancelAction':
        this.bodyTxt = `<span class="nested-text">Discard draft?</span>`;
        break;
      case 'commentEditAction':
        this.bodyTxt = `<span class="nested-text">Discard Edit comment?</span>`;
        break;
      case 'changeTrainingMode':
        this.bodyTxt = 'Are you sure you want to change training mode?';
        break;
      case 'refund':
        this.bodyTxt = 'Confirm refund.';
        break;
      case 'deleteTrainingNormal':
        this.bodyTxt = 'Are you sure you want to cancel the training?';
        break;
      case 'deleteSignedupTraining':
        this.bodyTxt = '<label class="text-align-left">There are people signed up. <br /> Are you sure you\'d like to cancel the training?</label>';
        break;
      case 'restoreTraining':
        this.bodyTxt = 'Are you sure you want to restore the training?';
        break;
      case 'restoreManual':
        this.bodyTxt = 'Are you sure you want to restore the manual?';
        break;
      case 'deleteTrainingPermanent':
        this.bodyTxt = 'Are you sure you want to delete the training?';
        break;
      case 'deleteManualPermanent':
        this.bodyTxt = 'Are you sure you want to delete the manual?';
        break;
      case 'deleteManualNormal':
        this.bodyTxt = 'Are you sure you want to remove the manual?';
        break;
      case 'deleteSignedupManual':
        this.bodyTxt = '<label class="text-align-left">There are people signed up. <br /> Are you sure you\'d like to cancel the manual?</label>';
        break;
      case 'deletePolicy':
        this.bodyTxt = 'Delete Policy?';
        break;
      case 'copyMasterSettings':
        this.bodyTxt = "Master's settings will be applied, your current settings will be overwritten?";
        break;
      case 'discardPricingInformation':
        this.bodyTxt = 'Alternate price is higher than early bird price. Are you sure want to continue?';
        break;
      case 'resendEmail':
        this.bodyTxt = 'Are you sure you want to resend email?';
        break;
      case 'updateTrainingEmails':
        this.bodyTxt = 'Do you want to send an update email to all the attendees?';
        break;
      case 'customer-status-active':
        this.bodyTxt = "<p>Are you sure you want to make this customer active?</p>"
        break;
      case 'customer-status-inactive':
        this.bodyTxt = "<p>Are you sure you want to make this customer inactive?</p><p>All business users will be deactivated and they can't login using their credentials.</p>"
        break;
      case 'est-job-notes':
        this.bodyTxt = "Are you sure you want to delete?";
        break;
      case 'cancel':
        this.bodyTxt = "Are you sure you want to Cancel?";
        break;
      case 'deleteTool':
        this.bodyTxt = 'Are you sure you want to delete this tool?';
        break;
      case 'confirmL1':
        this.bodyTxt = 'Are you sure you want to validate L1 Self Validation?';
        break;
      case 'confirmL2':
        this.bodyTxt = 'Are you sure you want to validate L2 Digitally Validation?';
        break;
      case 'confirmL3':
        this.bodyTxt = 'Are you sure you want to validate L3 On-Site Validation?';
        break;
      case 'download':
        this.bodyTxt = 'You are about to download the attachment excel. Do you want to proceed?';
        break;
      case 'download-attachment':
        this.bodyTxt = 'You are about to download a ZIP file containing tool images. Would you like to continue?';
        break;
      case 'l3_save':
        this.bodyTxt = 'The assessment report and gaps, if any, will be submitted for further review.';
        this.bodyTxt2 = `Tap 'Submit' to continue or 'Cancel' to make further changes.`;
        break;
      case 'alert':
      case 'delete-alert':
        this.bodyTxt = this.bodyTxtAlert;
        break;
      case 'cstripe-action-popup':
      case 'disconnect-qbo':  
        this.bodyTxt = this.title;
        break;
      case 'remove-attendee':
        this.bodyTxt = 'Are you sure you want to remove the attendee?';
        break;
      case 'removeDelete':
        this.bodyTxt = "Are you sure you’d like to remove this report?";
        break;
      case 'location-type-switch':
        this.bodyTxt = "Are you sure you want to change MSO to Signle Entity?";
        break;
      case 'confirm-close-task':
        this.bodyTxt = "Are you sure you want to close this task?";
        break;
    }
  }

  // Notify User Change
  notifyUserChange(status) {
    this.notifyFlag = (status == 1) ? true : false;
  }

  // Confirmation Action
  confAction(flag) {
    this.confirmAction.emit(flag)
  }

  // Confirmation Notify Action
  confNotifyAction(flag) {
    let notifyRes = {
      'notify': this.notifyFlag,
      'action': flag
    };
    this.confirmAction.emit(notifyRes);
  }
  closeModal() {
    this.activeModal.close('Ok click');
  }
  ngOnDestroy(){
    this.bodyElem.classList.remove("auth-open-remove-popup");
  }

}
